<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Transaction history</template>

    <Sheet.Body>
      <div class="mb-[14px]">
        History of your copyright since it was created.
      </div>
      <TransactionCard
        v-for="(transaction, index) in transactions"
        :key="index"
        :transaction="transaction"
        class="mb-2.5 last:mb-0"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import type { Transaction } from '@/shared/graphql/legacy/generated'
import TransactionCard from '@/features/billing/components/TransactionCard.vue'

defineProps<{
  transactions: Transaction[]
}>()

const { close } = useSheet()
</script>
